import React from 'react';

interface NotificationBodyTextProps {
    bold?: boolean;
    children: React.ReactNode;
}

const NotificationBodyText: React.FC<NotificationBodyTextProps> = ({ bold, children }) => (
    <p className="cop-notification__description">
        {bold ? <strong>{children}</strong> : children}
    </p>
);

export default NotificationBodyText;
